var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-row',[_c('vs-col',{staticClass:"d-flex",staticStyle:{"justify-content":"space-between"}},[_c('span',[_vm._v("TRACKING: "+_vm._s(_vm.$store.state.id))]),_c('button',{on:{"click":_vm.clearFiles}},[_vm._v("CLEAR FILES")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }